import React from "react";
import PropTypes from "prop-types";
import {ControlLabel, FormGroup} from "react-bootstrap";
import Box from "../component/Box/Box";
import FormButtons from "../component/Form/FormButtons";
import Loading from "../component/Loading/Loading";
import Notify from "../services/Notify";
import Objects from "../utils/Objects";
import CompanyConfigurationService from "../services/CompanyConfiguration"
import CheckpointSelector from "../checkpoint/CheckpointSelector";
import CheckboxWithLabel from "../component/Checkbox/CheckBoxWithLabel";

class CompanyConfigurationForm extends React.Component {
  service = new CompanyConfigurationService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.service.findById(id).then(
        data => {
          this.setState(
            {
              loading: false,
              entity: data
            });
        },
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
      )
    }
  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity ? this.state.entity.version : null;
    const entity = {
      id: existingEntity,
      key: this.key.value,
      value: this.value && this.value.value ? this.value.value : this.state.value,
      version: entityVersion
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.save(entity).then(
      () => {
        this.props.history.goBack();
        Notify.success('Configuração salva');
      },
      (error) => {
        Notify.error('Falha ao salvar configuração:', error);
        this.setState({loading: false, message: null});
      });
  }

  switchTypes(key) {
    const {entity} = this.state;
    switch (key) {
      case 'INVENTORY_CHECKPOINT_UNEXPECTED':
      case 'INVENTORY_CHECKPOINT_NOT_FOUND':
        return <CheckpointSelector onChange={e => this.setState({value: e && e.id})} defaultValue={entity && entity.value}/>

      case 'CAN_DO_TRANSACTION_SAME_LSD':
        return <CheckboxWithLabel
          label='Ativo' setValue={e => this.setState({value: e.target.checked})}/>
      default:
        return <FormGroup>
          <ControlLabel>Valor</ControlLabel>
          <input type="text" className="form-control" placeholder="Valor"
                 required
                 name="value"
                 ref={value => this.value = value}
                 defaultValue={entity && entity.value}/>
        </FormGroup>
    }
  }

  render() {
    const {loading, entity, message} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }
    return (
      <Box info>
        <form ref={form => (this.form = form)} onSubmit={event => {
          event.preventDefault();
          this.submitForm()
        }}>
          <FormGroup>
            <ControlLabel>Tipo</ControlLabel>
            <input type="text" className="form-control" placeholder="Tipo"
                   disabled='true'
                   name="key"
                   ref={key => this.key = key}
                   defaultValue={entity && entity.key}/>
          </FormGroup>
          {this.switchTypes(entity.key)}
          <FormButtons history={this.props.history}/>
        </form>

      </Box>);
  }

  filterItems(item) {
    const {entity} = this.state;
    return Objects.isNullOrUndefined(entity) ? true : item.id !== entity.id;
  }
}

CompanyConfigurationForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};
export default CompanyConfigurationForm;


// WEBPACK FOOTER //
// ./src/CompanyConfigurations/CompanyConfigurationForm.js